import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import "../../styles/ContractSection.css";
import {
  fadeUpItem,
  revealViewport,
} from "../animations/animationVariants";

const ContactSection = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/contact');
  }

  return (
    <section className="contact-section">
      <motion.span
        className="section-eyebrow"
        variants={fadeUpItem}
        initial="hidden"
        whileInView="visible"
        viewport={revealViewport}
      >
        04 / Connect
      </motion.span>
      <motion.h2
        className="contact-title"
        variants={fadeUpItem}
        initial="hidden"
        whileInView="visible"
        viewport={revealViewport}
      >
        Let's Talk<em className="contact-title-dot">.</em>
      </motion.h2>

      <motion.p
        className="contact-description"
        variants={fadeUpItem}
        initial="hidden"
        whileInView="visible"
        viewport={revealViewport}
      >
        Aura 플랫폼으로 예술·공간·브랜드 경험을 직접 확장해 보세요. 프로젝트 문의를 환영합니다.
      </motion.p>

      <motion.div
        className="contact-button-wrap"
        variants={fadeUpItem}
        initial="hidden"
        whileInView="visible"
        viewport={revealViewport}
      >
        <button className="contact-button" onClick={handleClick}>
          문의 하러가기<span className="btn-arrow" aria-hidden="true">→</span>
        </button>
      </motion.div>
    </section>
  );
};

export default ContactSection;
